module.exports = __webpack_public_path__ + "static/media/redassetmegawide.dd1d6dc7.PNG";